import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const MapPinIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M7.48615 14.7175C3.70234 8.95788 3 8.36676 3 6.25C3 3.3505 5.23857 1 8 1C10.7614 1 13 3.3505 13 6.25C13 8.36676 12.2977 8.95788 8.51385 14.7175C8.26555 15.0942 7.73443 15.0941 7.48615 14.7175Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0834 6.1475C10.0834 7.29902 9.15068 8.2325 8.00008 8.2325C6.84948 8.2325 5.91675 7.29902 5.91675 6.1475C5.91675 4.99598 6.84948 4.0625 8.00008 4.0625C9.15068 4.0625 10.0834 4.99598 10.0834 6.1475Z"
      fill="currentColor"
    />
  </svg>
));
